module.exports = __webpack_public_path__ + "img/tabs-Credit-Card.3fa57cc.svg";